export enum ProposalStatus {
    Open = 0,
    Accepted = 1,
    Dismissed = 2,
    Expired = 3,
}

export const ProposalStatusText: Record<ProposalStatus, string> = {
    [ProposalStatus.Open]: 'Ready to sign',
    [ProposalStatus.Accepted]: 'Accepted',
    [ProposalStatus.Dismissed]: 'Dismissed',
    [ProposalStatus.Expired]: 'Expired',
};

export const ProposalStatusColor: Record<ProposalStatus, string> = {
    [ProposalStatus.Open]: 'warning',
    [ProposalStatus.Accepted]: 'success',
    [ProposalStatus.Dismissed]: 'critical',
    [ProposalStatus.Expired]: 'inactive',
};

export const ProposalStatusTagSubtle = {
    [ProposalStatus.Open]: true,
    [ProposalStatus.Accepted]: true,
    [ProposalStatus.Dismissed]: true,
    [ProposalStatus.Expired]: true,
};
